import { useState, type SyntheticEvent } from 'react';

export const usePersistedTabIndex = (blockKey: string, tabCount?: number) => {
  const storageKey = `detail_form_tab:${blockKey}`;

  const [activeTab, setActiveTab] = useState<number>(() => {
    try {
      const stored = sessionStorage.getItem(storageKey);
      const parsed = parseInt(stored ?? '', 10);
      if (Number.isNaN(parsed) || parsed < 0) return 0;
      // If we know the tab count upfront and the stored index is out of range — reset to 0
      if (tabCount !== undefined && parsed >= tabCount) {
        sessionStorage.removeItem(storageKey);
        return 0;
      }
      return parsed;
    } catch {
      return 0;
    }
  });

  const handleTabChange = (_event: SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
    try {
      sessionStorage.setItem(storageKey, String(newValue));
    } catch {
      // ignore — private browsing mode
    }
  };

  return { activeTab, handleTabChange };
};
